(function () {
  if (window.OnePillowTransitionMediaLoaded) return;
  window.OnePillowTransitionMediaLoaded = true;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var observer = null;

  function isVisible(video) {
    return video.offsetParent !== null && video.getClientRects().length > 0;
  }

  function pause(video) {
    if (!video.paused) video.pause();
  }

  function play(video) {
    if (reducedMotion.matches || !isVisible(video)) {
      pause(video);
      return;
    }

    video.preload = 'metadata';
    var playback = video.play();
    if (playback && typeof playback.catch === 'function') playback.catch(function () {});
  }

  function getObserver() {
    if (observer || !('IntersectionObserver' in window)) return observer;

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            play(entry.target);
          } else {
            pause(entry.target);
          }
        });
      },
      { rootMargin: '240px 0px', threshold: 0.01 }
    );

    return observer;
  }

  function init(root) {
    var scope = root || document;
    var videos = scope.querySelectorAll('.op-transition-native__video');
    var mediaObserver = getObserver();

    videos.forEach(function (video) {
      if (video.dataset.opTransitionMediaReady === 'true') return;
      video.dataset.opTransitionMediaReady = 'true';
      video.autoplay = false;
      video.preload = 'none';
      video.querySelectorAll('img').forEach(function (posterImage) {
        posterImage.alt = '';
      });

      if (mediaObserver) {
        mediaObserver.observe(video);
      } else if (!reducedMotion.matches && isVisible(video)) {
        play(video);
      }
    });
  }

  function refresh() {
    document.querySelectorAll('.op-transition-native__video').forEach(function (video) {
      var rect = video.getBoundingClientRect();
      var nearViewport = rect.bottom >= -240 && rect.top <= window.innerHeight + 240;
      if (nearViewport) play(video);
      else pause(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  reducedMotion.addEventListener('change', refresh);
  window.addEventListener('resize', refresh, { passive: true });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
